import { render, staticRenderFns } from "./App.vue?vue&type=template&id=97f8638c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "@/../public/css/components/forms.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/../public/css/components/button.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "@/../public/css/components/badge.css?vue&type=style&index=2&prod&lang=css&external"
import style3 from "@/../public/css/components/colors.css?vue&type=style&index=3&prod&lang=css&external"
import style4 from "./App.vue?vue&type=style&index=4&id=97f8638c&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports